import { map, take } from 'rxjs/operators';


import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromAuth from '../reducers';

@Injectable()
export class LoggedInGuard implements CanActivate {
  constructor(private store: Store<fromAuth.State>,
              private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.pipe(
      select(fromAuth.getLoggedIn),
      take(1),
      map(authed => {
        if (authed) {
          this.router.navigate(['/'])
          return false;
        }

        return true;
      }))
  }
}
